// Gatsby doesn't include the recommended exceptions to this rule
/* eslint-disable jsx-a11y/no-noninteractive-element-to-interactive-role */
// https://github.com/evcohen/eslint-plugin-jsx-a11y/blob/master/docs/rules/no-noninteractive-element-to-interactive-role.md#rule-details

import React, { useEffect, createContext, useContext } from 'react';
import { Link } from 'gatsby';
import cx from 'classnames';
import {
  list,
  link,
  active,
  hidden,
  tab,
} from './GlobalSearch.module.scss';

export const MenuContext = createContext();

const Menu = ({ results, onKeyDown,searchIsOpen }) => {
  const { optionsRef } = useContext(MenuContext);

  // clear the options list every render so it will always be fresh
  useEffect(() => {
    optionsRef.current = [];
    return () => (optionsRef.current = []);
  });
  // Results must at least have a title to show up in the list
  const filteredResults = results.filter((result) => result.title );

  // In the event two pages have the same title, we need to add a tab to distinguish them in the results list
  const resultsWithTabAdded = filteredResults.map((result) => {
    const matchingResults = filteredResults.filter(
      (otherResult) => otherResult.title === result.title
    );
    if (matchingResults.length > 1) {
      return {
        ...result,
        tab: result.path
        .split('/')
        .filter(Boolean)
        .slice(-2, -1)[0]
      };
    }
    return result;
  });

  return (
    <ul
      aria-labelledby="search-label"
      role="menu"
      id="search-menu"
      aria-hidden={!searchIsOpen || results.length === 0}
      className={cx(list, {
        [hidden]: results.length === 0,
      })}>
      {resultsWithTabAdded.map((page, index) => (
        <MenuItem
          id={`menu-item-${index}`}
          onKeyDown={onKeyDown}
          key={page.path}
          index={index}
          page={page}
        />
      ))}
    </ul>
  );
};

const MenuItem = ({ page, index, onKeyDown, id }) => {
  const { optionsRef, focusedItem, clearAndClose } = useContext(MenuContext);

  useEffect(() => {
    optionsRef.current.push(page.path);
  });

  const className = cx(link, {
    [active]: focusedItem === index,
  });

  function convertFilePathToUrl(filePath) {
    const pagesIndex = filePath.lastIndexOf('/pages/');
    if (filePath.lastIndexOf('/pages/') === -1) return null;

    const fileName = filePath.slice(
      pagesIndex + '/pages/'.length,
      -'.mdx'.length
    );
    const normalizedFileName = fileName.endsWith('/index')
      ? fileName.slice(0, -'/index'.length)
      : fileName;
    const urlPath = `/${normalizedFileName.split('/').join('/')}/`;

    return urlPath;
  }

  const url = convertFilePathToUrl(page.path);

  return (
    <li role="none" key={page.id}>
      <Link
        onClick={clearAndClose}
        onKeyDown={onKeyDown}
        tabIndex={page.title ? 0 : -1}
        id={id}
        role="menuitem"
        className={className}
        to={url}>
        {page.title}&nbsp;
        {page.tab && (
          <span className={tab}>→ {page.tab.replace(/\.mdx$/, '')} </span>
        )}
      </Link>
    </li>
  );
};

export default Menu;
